module.exports = __webpack_public_path__ + "img/Mini Hesston 0.8 x 0.9.6886cc32.jpg";